import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';

interface StatusFornecedor {
  id: number;
  descricao: string;
}

@Component({
  selector: 'app-status-fornecedor',
  templateUrl: './status-fornecedor.component.html',
  styleUrls: ['./status-fornecedor.component.scss']
})
export class StatusFornecedorComponent implements OnInit {
  descricao = '';
  filtroDescricao = '';
  itens: StatusFornecedor[] = [];
  itensFiltrados: StatusFornecedor[] = [];
  itensPaginados: StatusFornecedor[] = [];
  itemEdicao: StatusFornecedor | null = null;
  modalRef: NgbModalRef | null = null;

  loading = false;
  paginaAtual = 1;
  itensPorPagina = 10;

  constructor(
    private modalService: NgbModal,
    private ajaxService: AjaxService,
    private util: UtilService
  ) {}

  ngOnInit(): void {
    this.carregar();
  }

  get totalPaginas(): number {
    return Math.ceil(this.itensFiltrados.length / this.itensPorPagina) || 1;
  }

  carregar(): void {
    this.loading = true;
    this.util.showLoading();
    this.ajaxService.get(`${API}financeiro/FinStatusFornecedor/ConsultarFinStatusFornecedor`).subscribe({
      next: (response) => {
        this.loading = false;
        this.util.closeLoading();
        const lista = this.normalizarLista(response?.data);
        this.itens = lista.map((x: any) => {
          const item = this.util.converterParaLowercase(x || {});
          return {
            id: Number(item.id || 0),
            descricao: String(item.descricao || '').trim()
          } as StatusFornecedor;
        }).filter((x: StatusFornecedor) => x.id > 0);
        this.aplicarFiltros();
      },
      error: () => {
        this.loading = false;
        this.util.closeLoading();
        this.itens = [];
        this.itensFiltrados = [];
        this.itensPaginados = [];
        this.util.toasterShowError('Erro', 'Não foi possível carregar status de fornecedor.');
      }
    });
  }

  novo(): void {
    this.itemEdicao = null;
    this.descricao = '';
  }

  editar(item: StatusFornecedor): void {
    this.itemEdicao = item;
    this.descricao = item.descricao;
  }

  abrirModalCadastro(content: TemplateRef<any>, item?: StatusFornecedor): void {
    if (item) {
      this.editar(item);
    } else {
      this.novo();
    }
    this.modalRef = this.modalService.open(content, { size: 'lg' });
  }

  salvar(): void {
    const descricao = String(this.descricao || '').trim();
    if (descricao.length < 2) {
      this.util.toasterShowError('Atenção', 'Informe uma descrição válida.');
      return;
    }

    const payload = {
      id: this.itemEdicao?.id || 0,
      descricao
    };

    this.util.showLoading();
    this.ajaxService.post(`${API}financeiro/FinStatusFornecedor/Salvar`, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível salvar.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', this.itemEdicao ? 'Registro atualizado com sucesso!' : 'Registro criado com sucesso!');
        this.modalRef?.close();
        this.novo();
        this.carregar();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao salvar status de fornecedor.');
      }
    });
  }

  deletar(item: StatusFornecedor): void {
    this.util.showLoading();
    this.ajaxService.post(`${API}financeiro/FinStatusFornecedor/Deletar`, { id: item.id }).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível excluir.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', 'Registro excluído com sucesso!');
        if (this.itemEdicao?.id === item.id) {
          this.novo();
        }
        this.carregar();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao excluir status de fornecedor.');
      }
    });
  }

  aplicarFiltros(): void {
    const termo = String(this.filtroDescricao || '').toLowerCase().trim();
    this.itensFiltrados = this.itens.filter(x => !termo || x.descricao.toLowerCase().includes(termo));
    this.paginaAtual = 1;
    this.atualizarPaginacao();
  }

  limparFiltros(): void {
    this.filtroDescricao = '';
    this.aplicarFiltros();
  }

  paginaAnterior(): void {
    if (this.paginaAtual > 1) {
      this.paginaAtual--;
      this.atualizarPaginacao();
    }
  }

  proximaPagina(): void {
    if (this.paginaAtual < this.totalPaginas) {
      this.paginaAtual++;
      this.atualizarPaginacao();
    }
  }

  alterarItensPorPagina(): void {
    this.paginaAtual = 1;
    this.atualizarPaginacao();
  }

  private atualizarPaginacao(): void {
    const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
    const fim = inicio + this.itensPorPagina;
    this.itensPaginados = this.itensFiltrados.slice(inicio, fim);
  }

  private normalizarLista(data: any): any[] {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (typeof data === 'object') {
      if (Object.prototype.hasOwnProperty.call(data, 'id') || Object.prototype.hasOwnProperty.call(data, 'descricao')) {
        return [data];
      }
      return Object.values(data).filter((x: any) => x && typeof x === 'object');
    }
    return [];
  }
}
